import { Ymxxinit,HtxxSelect,zcxwSave,getZcxwxxByid } from '@/api/comment'
import { setToken, getToken, setUserId, getUserId } from '@/libs/util'
const state = {
  userName: '',
  userId: getUserId(),
  token: getToken(),
}

const actions = {
  Ymxxinit ({ commit }, param) {
    return new Promise((resolve, reject) => {
      Ymxxinit(param).then(res => {
        console.log('userPage#response', res)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  HtxxSelect ({ commit }, param) {
    return new Promise((resolve, reject) => {
      HtxxSelect(param).then(res => {
        console.log('userPage#response', res)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getZcxwxxByid ({ commit }, param) {
    return new Promise((resolve, reject) => {
      HtxxSelect(param).then(res => {
        console.log('userPage#response', res)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  zcxwSave ({ commit }, param) {
    return new Promise((resolve, reject) => {
      zcxwSave(param).then(res => {
        console.log('userPage#response', res)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  warnMessage2(obj) {
    alert(11)
  }

}
const mutations = {
  setUserId (state, id) {
    state.userId = id
    setUserId(id)
  },
  setUserName (state, name) {
    state.userName = name
  },
  setToken (state, token) {
    state.token = token
    setToken(token)
  },
}

export default {
  state,
  actions,
  mutations
}
